import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import { ResponsivePie } from '@nivo/pie';

// https://www.npmjs.com/package/react-d3-speedometer
// https://nivo.rocks/pie/

const colors2 = ['#39cd33', '#ff481b', '#007bff', '#eae825'];

class Commission extends Component {
	renderTooltip = (d) => {
		return (
			<div style={{ whiteSpace: 'pre', display: 'flex', alignItems: 'center' }}>
				<span
					style={{
						display: 'block',
						width: '12px',
						height: '12px',
						background: d.color,
						marginRight: '7px',
					}}
				></span>
				{d.label}
				{/* : <strong>R$ {this.props.toBrCurrency(d.value)}</strong> */}
			</div>
		);
	};

	render() {
		const { comissao, tip } = this.props;
		return (
			<div className="div-indicador">
				<Card>
					<Card.Header style={{ fontWeight: 'bold' }}>
						Comissão
						<div data-tip={tip} className="fas fa-info-circle ml-1" />
					</Card.Header>
					<Card.Body>
						<div className="pie">
							<ResponsivePie
								data={comissao}
								sliceLabel={(e) => {
									return 'R$ ' + this.props.toBrCurrency(e.value);
								}}
								margin={{ top: 0, right: 0, bottom: 0, left: 10 }}
								innerRadius={0.35}
								padAngle={2}
								slicesLabelsSkipAngle={45}
								colors={colors2}
								borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
								enableRadialLabels={false}
								animate={true}
								motionStiffness={90}
								motionDamping={15}
								tooltip={(d) => this.renderTooltip(d)}
								legends={[
									{
										anchor: 'bottom-left',
										direction: 'column',
										translateY: 0,
										translateX: -10,
										itemWidth: 20,
										itemHeight: 14,
										itemTextColor: '#999',
										symbolSize: 10,
										symbolShape: 'circle',
										effects: [
											{
												on: 'hover',
												style: {
													itemTextColor: '#000',
												},
											},
										],
									},
								]}
							/>
						</div>
					</Card.Body>
				</Card>
			</div>
		);
	}
}

export default Commission;
